
<ngb-carousel  class="carousel position-absolute slide w-100 carousel-fade" [showNavigationArrows]="false" [showNavigationIndicators]="true" >
  <ng-template ngbSlide *ngFor="let imagen of imagenes; let j=index">
    <div class="carousel-inner bg-tour-detail tours-height">
      <div class=" carousel-item active" style="z-index: 0;">
        <img [src]="imagen.imagen" class="d-block " alt="..." style="height: 100% !important; width: -webkit-fill-available; object-fit: cover;">
      </div>
   </div>
  </ng-template>
</ngb-carousel>
 
  <section class="align-items-center d-flex tours-height" >
      <div class="position-relative tour-detail-title w-100">
          <div class="container">
              <div class="row mb-5">
                  <div class="col-lg-1">
                      <a href="javascript:history.back()" class="d-flex flex-row align-items-center text-decoration-none">
                          <img src="assets/images/body/icons/volver.svg" class="pe-2" alt="">
                          <h4 class="text-white mb-0"> Volver</h4>
                      </a>
                  </div>
              </div>
              <div class="row ">
                  <div class="col-lg-12">
                      <h1 class="mb-1 text-white">{{tourDetail?.nombre_paquete}}</h1>
                  </div>
              </div>
          </div>
      </div>
  </section>
<!--  -->
<section class="tour-detail-content" style="padding-top: 10rem; margin-top: -35px;">
  <div class="container">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-12 pb-2">
        <h4 class="title-bg mb-5">Itinerario</h4>
      </div>
    </div>
    <!-- nuevo carrusel -->
    <div class="row">
      <ngb-carousel id="carouselExampleFade" class="carousel slide itinerario carousel-fade "  [showNavigationArrows]="showArrows" [showNavigationIndicators]="showIndicators" [interval]="3000">
        <ng-template ngbSlide *ngFor="let itinerary of itineraries; let j=index">
          <div class="carousel-inner bg-grey">
            <div class="carousel-item active w-100">
              <div class="row">
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-12 position-relative h-100">
                    <div class="bg-primary tours-pasajeros overflow-hidden h-100">
                      <img [src]="itinerary.imagen" class="d-block" alt="..." style="height: 450px !important; width: -webkit-fill-available; object-fit: cover;" >
                    </div>
                </div>  
                <div class="col-xxl-6 col-xl-6 col-lg-6 col-12 margin-left-">
                    <div class="pt-lg-5 pt-3 pb-lg-4 pb-3 pe-lg-5 pe-3 ps-3 ps-lg-0 bg-grey h-100 radius-30">
                      <div *ngFor="let itineraryDetail of itinerary.list">
                        <h3 class="text-secondary">{{itineraryDetail.titulo_actividad}}: </h3>
                        <p class="mb-4">{{itineraryDetail.descripcion_actividad}}</p>
                      </div>
                    </div>
                </div>  
              </div>
            </div>
          </div>
        </ng-template>
        <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
          <span class="carousel-control-prev-icon" aria-hidden="true"></span>
          <span class="sr-only">Previous</span>
        </a>
        <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
          <span class="carousel-control-next-icon" aria-hidden="true"></span>
          <span class="sr-only">Next</span>
        </a>  
        </ngb-carousel>

    </div>
    <!-- nuevo carrusel end-->

    <!-- <ngb-carousel *ngIf="itineraries?.length>0" [showNavigationArrows]="true" [showNavigationIndicators]="false" [interval]="5000" class="carousel slide carousel-fade">

      <ng-template ngbSlide *ngFor="let itinerary of itineraries; let j=index">      
        <div class="carousel-item  active w-100" >
          <div class="row">
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-12 position-relative h-100">
              <div class="bg-primary tours-pasajeros ps-0 overflow-hidden h-100">
                <img [src]="itinerary.imagen" class="d-block"  style="height: 450px !important; width: -webkit-fill-available; object-fit: cover;" alt="...">
              </div>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-6 col-12 margin-left-">
              <div class="pt-lg-5 pt-3 pb-lg-4 pb-3 pe-lg-5 pe-3 ps-3 ps-lg-0 bg-grey h-100 radius-30">
                <div *ngFor="let itineraryDetail of itinerary.list">
                  <h3 class="text-secondary">{{itineraryDetail.titulo_actividad}}: </h3>
                  <p class="mb-4">{{itineraryDetail.descripcion_actividad}}</p>
                </div>
              </div>
            </div>
          </div>
        </div>      
    </ng-template>
      <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>    
  </ngb-carousel> -->
  </div>
</section>

<section class="pb-5 " >
  <div class="container">
    <div class="row">
      <div class="col-xl-1 col-xxl-2"></div>
      <div class="col-12 pb-2">
        <h4 class="title-bg mb-5">Excursiones Opcionales</h4>
      </div>
    </div>
    <div class="row">
    <ngb-carousel *ngIf="opcionalExcursion?.length>0" [showNavigationArrows]="showArrows" [showNavigationIndicators]="showIndicators" [interval]="5000" class="carousel slide itinerario carousel-fade">
      <ng-template ngbSlide *ngFor="let opc of opcionalExcursion; let j=index">
         <div class="carousel-inner"> 
        <div class="carousel-item active" style="width: 100% !important;">
          <div class="row">
            <div class="col-xxl-6 col-xl-6 pe-lg-0 col-lg-6 margin-right-">
              <div class="pt-lg-5 pt-3 pb-lg-4 pb-3 pe-lg-5 pe-3 ps-3 ps-lg-5 bg-grey h-100 radius-30">
                <div *ngFor="let opcDetail of opc.list">
                  <div class="d-flex flex-row align-items-center mb-5 excursion-text">
                    <img src="assets/images/body/tours/excursion-icono.svg" class="excursion-icon me-3" alt="">
                    <div>
                      <h4 class="">{{opcDetail.titulo}}</h4>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-xxl-6 col-xl-6 col-lg-6 ps-lg-0 position-relative h-100">
              <div class="bg-primary tours-pasajeros ps-0 overflow-hidden h-100">
                <img [src]="opc.imagen" class="d-block" style="height: 450px !important; width: -webkit-fill-available; object-fit: cover;" alt="...">
              </div>
            </div>
          </div>
        </div>
       </div> 
      </ng-template>
      <a class="carousel-control-prev" href="#carouselExampleFade" role="button" data-slide="prev" >
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleFade" role="button" data-slide="next" >
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </ngb-carousel>
  </div>
  </div>
</section>

<section class="mt-5">
  <div class="container">
    <div class="row">
      <div class="col-12 z-index--top">
        <h4 class="text-secondary">Observaciones</h4>
        <span>{{tourDetail?.observaciones_paquete}}
        </span>
      </div>
    </div>
  </div>
</section>
<section class="bg-home bg-tour-details z-index-top-">
  <div class="container">
    <div class="row">
      <div class="col-12 text-center">

      </div>
    </div>
  </div>
</section>
